import GridViewIcon from '@mui/icons-material/GridView';
import ListIcon from '@mui/icons-material/List';
import { ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { DisplayMode } from '../search/state/state';
import { wishlistDisplayModeAtom } from './state';

export default function WishlistViewToggle(): React.JSX.Element {
  const [displayMode, setDisplayMode] = useAtom(wishlistDisplayModeAtom);
  const theme = useTheme();
  const isSmallerThanLg = useMediaQuery(theme.breakpoints.down('lg'));

  useEffect(() => {
    if (isSmallerThanLg && displayMode === DisplayMode.LIST) {
      setDisplayMode(DisplayMode.GRID);
    }
  }, [isSmallerThanLg]);

  return (
    <ToggleButtonGroup
      onChange={(_, newMode) => {
        if (newMode !== null) {
          setDisplayMode(newMode);
        }
      }}
      value={displayMode}
      exclusive
      sx={{
        display: {
          xs: 'none',
          lg: 'flex',
        },
        width: 144,
        height: 48,
        padding: 0,
      }}
    >
      <ToggleButton value={DisplayMode.GRID}>
        <GridViewIcon sx={{ width: 18, height: 18 }} />
      </ToggleButton>
      <ToggleButton value={DisplayMode.LIST}>
        <ListIcon sx={{ width: 18, height: 18 }} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
